/**
 * Bulk product catalog for CLS-DK.
 * Mock data — no backend. Keyed by slug.
 *
 * NOTE (placeholder): reuses ABC-SE product images until CLS-specific
 * photography is available. Swedish slugs are kept for now so the two
 * brands share URL patterns; swap to Danish slugs once the backend /
 * catalog ships Danish content.
 */
import bulkFest from '../../../../assets/abc-se/accessories/party-overall.jpg';
import bulkVogn from '../../../../assets/abc-se/accessories/standard-overall.jpg';

export const BULK_PRODUCTS = {
  partyoverallen: {
    slug: 'partyoverallen',
    name: 'Festheldragten',
    price: '159,-',
    priceRaw: 159,
    description:
      'Klassisk heldragt i 100% bomuld med skjult knapluk. Særligt tilpasset til farvning. Skjult knappelukning foran. To lommer foran. Højre lomme har lynlås. Regellomme på højre ben. Klaplomme på venstre ben. Justerbar elastik i taljen. Løkker i taljen. Forstærket løkke på højre ben.',
    images: [
      { src: bulkFest, alt: 'Festheldragten' },
    ],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    minPerSize: 0,
    minTotal: 10,
  },
  flakoverallen: {
    slug: 'flakoverallen',
    name: 'Vognheldragten',
    price: '159,-',
    priceRaw: 159,
    description:
      'Holdbar standard-heldragt designet til vognparader og udendørs aktiviteter. 100% bomuld med forstærkede sømme, justerbar taljelinje, flere lommer til nytteformål og et klassisk studenterlook. Perfekt grundlag for farvning og tilpasning.',
    images: [
      { src: bulkVogn, alt: 'Vognheldragten' },
    ],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    minPerSize: 0,
    minTotal: 10,
  },
};

export const getBulkProduct = (slug) => BULK_PRODUCTS[slug] ?? null;
